import emailjs from "@emailjs/browser";
import React, { useState, useEffect } from "react";

// Initialize EmailJS with your Public Key
emailjs.init("LHN36zibZMdIZeRb7");
const sanitize = (value) => {
  if (typeof value === 'string') {
    return value.trim() === '' ? 'N/A' : value;
  }
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return value;
};

const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  // Return last 10 digits if more than 10, otherwise return all digits
  return digits.length > 10 ? digits.slice(-10) : digits;
};
// Store the initial landing URL
let initialLandingUrl = null;

// Function to get the source URL
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";

  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }

  return initialLandingUrl;
};

// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};


// Function to send construction form data
export const sendConstructionFormEmail = async (formData, trustedFormData) => {
  console.log("formData", formData);

  const currentYear = new Date().getFullYear();
  const submission_date = new Date().toLocaleString();

  try {
    const ipAddress = await getIPAddress();

    const templateParams = {
      // Basic Contact Info
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: "reachus@connectwithattorney.com",
      email: formData.email,
      phone_number: formData.phone,
      state: formData.state,

      // ⚠️ New Form Questions
      diagnosed_after_2000: formData.diagnosedAfter2000,
      used_talcum_powder: formData.usedTalcumPowder,
      brca_gene_mutation: formData.brcaGeneMutation,

      // Privacy + Captcha
      privacy_policy: formData.privacyPolicy ? "Yes" : "No",
      human_verification: formData.humanVerification ? "Yes" : "No",

      // Tracking & Meta
      ip_address: ipAddress,
      page_source: getSourceUrl(),
      submission_date,
      year: currentYear,

      // TrustedForm
      xxTrustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl,
      xxTrustedFormPingUrl: trustedFormData.xxTrustedFormPingUrl,
      xxTrustedFormCertToken: trustedFormData.xxTrustedFormCertToken,
    };

    // 👉 SEND ADMIN EMAIL
    const Promise_Admin = emailjs.send(
      "service_qs9v96e",
      "template_97iw59k",
      templateParams
    );

    // 👉 SEND USER CONFIRMATION
    const Promise_User = emailjs.send(
      "service_qs9v96e",
      "template_4bp8rkd",
      templateParams
    );
    const [response_Admin, response_User] = await Promise.all([Promise_Admin, Promise_User]);

    return { success: true, response_Admin, response_User };

  } catch (error) {
    console.error("Failed to send email:", error);
    return { success: false, error };
  }
};



export const sendToLeadProsper = async ({ formData }) => {
  try {
    const ipAddress = await getIPAddress();

    const leadProsperData = {
      lp_campaign_id: "30996",
      lp_supplier_id: "96284",
      lp_key: "goda5jnrux65q",
      lp_action: "",
      lp_subid1: "",
      lp_subid2: "",
      Source: "",

      first_name: formData.firstName || "",
      last_name: formData.lastName || "",
      email: formData.email || "",
      number1: cleanPhoneNumber(formData.phoneNumber) || "",

      street: "",
      city: "",
      zip: "",
      state: formData.state || "",
      date_of_birth: "",
      notes: "",
      external_id: "",
      ip_adress: ipAddress,

      // TrustedForm
      verification_id: formData.certId || "",

      Visit_Date: "",
    };

    const response = await fetch("https://api.leadprosper.io/direct_post", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(leadProsperData),
    });

    const result = await response.json();
    console.log("Lead Prosper API Response:", result);
    return result;
  } catch (error) {
    console.error("Failed to send to Lead Prosper API:", error);
    return { status: "ERROR", message: error.message };
  }
};
